import React, { useEffect } from 'react';
import MarketNavbar from './MarketNavbar';
import AdminSidebar, { SIDEBAR_WIDTH } from './AdminSidebar';

export default function MarketLayout({ children }) {
  useEffect(() => { document.title = 'DoorlyMarket | Secondary Market'; }, []);
  return (
    <>
      <MarketNavbar />
      <AdminSidebar />
      <div
        className="admin-sidebar-offset"
        style={{
          paddingTop: '64px',
          paddingLeft: `${SIDEBAR_WIDTH}px`,
          minHeight: '100vh',
          backgroundColor: '#f9fafb',
        }}
      >
        {children}
      </div>
    </>
  );
}
